// removed by extract-text-webpack-plugin
module.exports = {"oldColorBlack":"#4a4a4a","colorWine":"undefined","lgBreak":"1280px","unit":"5px","defaultLineHeight":"1.5","defaultFontSize":"16px"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/common/reset.css
// module id = 743
// module chunks = 0